import { render, staticRenderFns } from "./profile-subpage.vue?vue&type=template&id=cefe559c&lang=pug&"
import script from "./profile-subpage.vue?vue&type=script&lang=js&"
export * from "./profile-subpage.vue?vue&type=script&lang=js&"
import style0 from "./profile-subpage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports